"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=imgproc_object.js.map